(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var objectCreate = Object.create || objectCreatePolyfill
var objectKeys = Object.keys || objectKeysPolyfill
var bind = Function.prototype.bind || functionBindPolyfill

function EventEmitter() {
  if (!this._events || !Object.prototype.hasOwnProperty.call(this, '_events')) {
    this._events = objectCreate(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

var hasDefineProperty;
try {
  var o = {};
  if (Object.defineProperty) Object.defineProperty(o, 'x', { value: 0 });
  hasDefineProperty = o.x === 0;
} catch (err) { hasDefineProperty = false }
if (hasDefineProperty) {
  Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
      return defaultMaxListeners;
    },
    set: function(arg) {
      // check whether the input is a positive number (whose value is zero or
      // greater and not a NaN).
      if (typeof arg !== 'number' || arg < 0 || arg !== arg)
        throw new TypeError('"defaultMaxListeners" must be a positive number');
      defaultMaxListeners = arg;
    }
  });
} else {
  EventEmitter.defaultMaxListeners = defaultMaxListeners;
}

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    if (arguments.length > 1)
      er = arguments[1];
    if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Unhandled "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
      // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
      // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = objectCreate(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
          listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
          prepend ? [listener, existing] : [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
            existing.length + ' "' + String(type) + '" listeners ' +
            'added. Use emitter.setMaxListeners() to ' +
            'increase limit.');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        if (typeof console === 'object' && console.warn) {
          console.warn('%s: %s', w.name, w.message);
        }
      }
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    switch (arguments.length) {
      case 0:
        return this.listener.call(this.target);
      case 1:
        return this.listener.call(this.target, arguments[0]);
      case 2:
        return this.listener.call(this.target, arguments[0], arguments[1]);
      case 3:
        return this.listener.call(this.target, arguments[0], arguments[1],
            arguments[2]);
      default:
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i)
          args[i] = arguments[i];
        this.listener.apply(this.target, args);
    }
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = bind.call(onceWrapper, state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = objectCreate(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else
          spliceOne(list, position);

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = objectCreate(null);
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = objectCreate(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = objectKeys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = objectCreate(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (!events)
    return [];

  var evlistener = events[type];
  if (!evlistener)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function objectCreatePolyfill(proto) {
  var F = function() {};
  F.prototype = proto;
  return new F;
}
function objectKeysPolyfill(obj) {
  var keys = [];
  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k)) {
    keys.push(k);
  }
  return k;
}
function functionBindPolyfill(context) {
  var fn = this;
  return function () {
    return fn.apply(context, arguments);
  };
}

},{}],2:[function(require,module,exports){
"use strict";

require("../../../impv-resources/src/js/customers");

},{"../../../impv-resources/src/js/customers":5}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _filter = _interopRequireDefault(require("./filter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DashBoard =
/*#__PURE__*/
function () {
  function DashBoard(requiredFilter) {
    _classCallCheck(this, DashBoard);

    this.tilesAmount = $('#tiles-to-add').val() || 11;
    this.hideUnchosen = true;
    this.requiredFilter = requiredFilter;
    this.cards = $('.card-div').length >= 0 ? $('.outer-card') : $('.card-div').parent();
    this.init();
  }

  _createClass(DashBoard, [{
    key: "init",
    value: function init() {
      var _this = this;

      if ('php_vars' in window) {
        if (!window.php_vars.hideUnchosen) {
          this.hideUnchosen = false;
        }
      }

      var filter = new _filter["default"](this.hideUnchosen, this.requiredFilter);
      filter.on('filterCompleted', function () {
        _this.showMoreBtn();
      });
      this.showMoreBtn();
      $('.show-more-btn').on('click', function () {
        var counter = 0;

        _this.cards.each(function (_, e) {
          if ($(e).hasClass('show') && $(e).is(':hidden') && counter <= _this.tilesAmount) {
            counter++;
            $(e).fadeIn();
          }
        });

        _this.showMoreBtn();
      });
    }
  }, {
    key: "showMoreBtn",
    value: function showMoreBtn() {
      var counter = 0;

      if ($('.card-div').length >= 0) {
        $('.outer-card').each(function (_, e) {
          if ($(e).hasClass('show') && $(e).is(':hidden')) {
            counter++;
          }
        });
      } else {
        $('.card-div').parent().each(function (_, e) {
          if ($(e).hasClass('show') && $(e).is(':hidden')) {
            counter++;
          }
        });
      }

      if (counter == 0) {
        $('.show-more-div').hide();
      } else {
        $('.show-more-div').show();
      }
    }
  }]);

  return DashBoard;
}();

exports["default"] = DashBoard;

},{"./filter":4}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _events = require("events");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var urlParam = function urlParam(name) {
  var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href);

  if (results == null) {
    return null;
  }

  return decodeURI(results[1]) || 0;
};

var Filter =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(Filter, _EventEmitter);

  function Filter(hideUnchosen, requiredFilter) {
    var _this;

    _classCallCheck(this, Filter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Filter).call(this));
    _this.availableFilters = _this.mapPageFilters();
    _this.hideUnchosen = hideUnchosen;
    _this.requiredFilter = requiredFilter; // Setting specific filter to get priority

    _this.init();

    return _this;
  }

  _createClass(Filter, [{
    key: "init",
    value: function init() {
      this.initFilterButtonsUI();
      this.initFilterAction();
    }
  }, {
    key: "mapPageFilters",
    value: function mapPageFilters() {
      var availableFilters = $('.filter-btn-div.visible:not(.sort-by)').map(function (_, e) {
        var filterAttr = $(e).attr('filter');
        filterAttr = filterAttr.trim().replace(/\s+/g, '');
        filterAttr = filterAttr.toLowerCase();
        return filterAttr;
      }).toArray() || [];
      return availableFilters;
    }
  }, {
    key: "initFilterButtonsUI",
    value: function initFilterButtonsUI() {
      $('.filters-div .drop-down-btn').on('click', function (e) {
        // change icon on click to open the dropdown on mobile
        var applyFilterbtn = $(e.currentTarget);

        if (applyFilterbtn.hasClass('collapsed')) {
          applyFilterbtn.text('X Clear filters');
          $('.filter-hr').show();
        } else {
          applyFilterbtn.text('Apply filters');
          $('.filter-hr').hide();
          var firstFiltersBtn = $('.filter-btn-div.visible .filter-btns:not(.disabled):nth-child(1)');
          $.each(firstFiltersBtn, function (key, btnValue) {
            $(btnValue).trigger('click');
          });
        }
      });
      $('.apply-filter-btn,.drop-up-btn').on('click', function () {
        $('.filter-hr').hide();
        $('.drop-down-btn span').removeClass('fa-angle-down').addClass('fa-angle-right');
      });

      if (window.location.href.indexOf('orderby') > -1) {
        $(".filter-btns.sort-by[data-slug='newest']").removeClass('chosen');
        $(".filter-btns.sort-by[data-slug='most-popular']").addClass('chosen');
      }

      $(document).ready(function () {
        if (window.location.href.indexOf('category') > -1) {
          var categoriesRefresh = urlParam('category').split(',');
          $.each(categoriesRefresh, function (_, e) {
            $(".filter-btns[click-slug='" + e + "']").click();
          });
        }
      });
    }
  }, {
    key: "initFilterAction",
    value: function initFilterAction() {
      var _this2 = this;

      $('.filter-btns:not(.disabled)').on('click', function (e) {
        _this2.setBtnAsChosen($(e.currentTarget));

        if ($(e.currentTarget).hasClass('sort-by')) {
          _this2.sortCards($(e.currentTarget).attr('data-slug'));
        } else {
          _this2.filterResults(_this2.hideUnchosen, _this2.availableFilters, _this2.requiredFilter);
        }
      });
    }
  }, {
    key: "setBtnAsChosen",
    value: function setBtnAsChosen(currentBtn) {
      if (currentBtn.hasClass('chosen')) {
        if ((currentBtn.hasClass('radio') || currentBtn.hasClass('year')) && currentBtn.hasClass('chosen')) {
          currentBtn.siblings().removeClass('chosen');
        } else {
          currentBtn.removeClass('chosen');
          var filterClass = currentBtn.parent('.filter-btn-div').attr('filter');

          if (!currentBtn.siblings().hasClass('chosen')) {
            $('.' + filterClass + ' .filter-btns:not(.disabled).all').addClass('chosen');
          }
        }
      } else {
        if (currentBtn.hasClass('all') || currentBtn.hasClass('radio') || currentBtn.hasClass('year')) {
          currentBtn.siblings().removeClass('chosen');
        } else {
          currentBtn.siblings('.filter-btns.all').removeClass('chosen');
        }

        currentBtn.addClass('chosen');
      }
    }
  }, {
    key: "getChosenFilters",
    value: function getChosenFilters() {
      var ChosenFilters = this.availableFilters.reduce(function (acc, cur) {
        acc[cur] = $('.filter-btn-div.visible:not(.sort-by) .filter-btns:not(.disabled).' + cur + '.chosen').map(function (_, e) {
          return $(e).text().trim().replace(/[\W_]+/g, '').toLowerCase();
        }).toArray() || [];
        return acc;
      }, {});
      return ChosenFilters;
    }
  }, {
    key: "getCardsFilters",
    value: function getCardsFilters(currentCard) {
      var cardsFilters = this.availableFilters.reduce(function (acc, cur) {
        acc[cur] = $.trim(currentCard.closest('.outer-card').attr(cur)).toLowerCase().split(',').map(function (e, i) {
          return e ? e.toString().trim().replace(/[\W_]+/g, '') : '';
        }) || [];
        return acc;
      }, {});
      return cardsFilters;
    }
  }, {
    key: "filterResults",
    value: function filterResults() {
      var _this3 = this;

      var chosenFilters = this.getChosenFilters();
      $('.card-div').each(function (_, e) {
        var $currentCard = $(e);
        $currentCard.closest('.show').each(function (_, e) {
          $(e).removeClass('show');
        });

        var cardsFilters = _this3.getCardsFilters($currentCard);

        _this3.markResults(chosenFilters, cardsFilters, $currentCard);
      });
      this.showResults();
    }
  }, {
    key: "markResults",
    value: function markResults(chosenFilters, cardsFilters, $currentCard) {
      var show = false;
      var filterChosen = false;
      $.each(chosenFilters, function (key, value) {
        if (value.length != 0) {
          filterChosen = true;
        }
      });

      if (!filterChosen) {
        show = true;
      } else {
        show = false;
        $.each(chosenFilters, function (item) {
          var arr = chosenFilters[item];
          var categoryCounter = arr.length ? 0 : 1;
          chosenFilters[item].forEach(function (param) {
            console.log(cardsFilters[item], cardsFilters[item].indexOf(param));

            if (cardsFilters[item].indexOf(param) > -1) {
              categoryCounter++;
            }
          });
          console.log(categoryCounter);

          if (categoryCounter) {
            show = true;
          } else {
            show = false;
            return false;
          }
        });
      }

      if (show) {
        $currentCard.closest('.outer-card').addClass('show');
      }
    }
  }, {
    key: "showResults",
    value: function showResults() {
      var counter = 0;
      var tilesAmount = $('#tiles-to-add').val() || 11;

      if (this.hideUnchosen) {
        $('.card-div').each(function (_, e) {
          if ($(e).closest('.outer-card').hasClass('show') && counter <= tilesAmount) {
            counter++;
            $(e).closest('.outer-card').fadeIn();
          } else if ($(e).closest('.outer-card').hasClass('show') && counter > tilesAmount) {
            $(e).closest('.outer-card').hide();
          } else {
            $(e).closest('.outer-card').fadeOut();
          }
        });
      } else {
        $('.card-div').each(function (_, e) {
          if ($(e).closest('.outer-card').hasClass('show') && counter <= tilesAmount) {
            counter++;
            $(e).closest('.outer-card').fadeIn();
            $(e).closest('.outer-card').addClass('order-1').removeClass('order-2').removeClass('grey-box');
          } else if ($(e).closest('.outer-card').hasClass('show') && counter >= tilesAmount) {
            $(e).closest('.outer-card').hide().addClass('order-1').removeClass('order-2').removeClass('grey-box');
          }
        });
        $('.card-div').each(function (_, e) {
          if (!$(e).closest('.outer-card').hasClass('show') && counter <= tilesAmount) {
            $(e).closest('.outer-card').removeClass('order-1').show().addClass('order-2').addClass('grey-box');
            counter++;
          } else if (!$(e).closest('.outer-card').hasClass('show') && counter > tilesAmount) {
            $(e).closest('.outer-card').hide().removeClass('order-1').addClass('order-2').addClass('show').addClass('grey-box');
          }
        });
      }

      this.emit('filterCompleted');
    }
  }, {
    key: "sortCards",
    value: function sortCards($order) {
      var $currentURL = window.location.href;
      var $chosenfilters = '';

      if (window.location.href.indexOf('category') > -1) {
        $currentURL = $currentURL.replace('&category=' + urlParam('category'), '');
        $currentURL = $currentURL.replace('?category=' + urlParam('category'), '');
      }

      if (!$.isEmptyObject(this.getChosenFilters()) && $('.filter-btn-div.visible:not(.sort-by) .filter-btns:not(.all).chosen').length) {
        $chosenfilters = '&category=' + $.map(this.getChosenFilters(), function (e) {
          return e;
        }).join(',');
        $currentURL;
      } else {
        $currentURL = $currentURL.replace('&category=' + urlParam('category'), '');
        $currentURL = $currentURL.replace('?category=' + urlParam('category'), '');
      }

      if ($order == 'most-popular') {
        var $urlQueryString;

        if ($currentURL.indexOf('orderby=views') <= -1) {
          $urlQueryString = $currentURL.indexOf('?') <= -1 ? '?orderby=views' : '&orderby=views';
          $currentURL = $currentURL + $urlQueryString;

          if ($currentURL.indexOf('?') <= -1) {
            $chosenfilters = $chosenfilters.replace('&category', '?category');
          } else {
            $chosenfilters = $chosenfilters.replace('?category', '&category');
          }

          window.location.href = $currentURL + $chosenfilters;
        }
      } else {
        var queryToRemove = '';

        if ($currentURL.indexOf('&orderby=views') > -1) {
          queryToRemove = '&orderby=views';
        } else if ($currentURL.indexOf('?orderby=views') > -1 && $currentURL.indexOf('&') > -1) {
          queryToRemove = 'orderby=views&';
        } else {
          queryToRemove = '?orderby=views';
        }

        $currentURL = $currentURL.replace(queryToRemove, '');

        if ($currentURL.indexOf('?') <= -1) {
          $chosenfilters = $chosenfilters.replace('&category', '?category');
        } else {
          $chosenfilters = $chosenfilters.replace('?category', '&category');
        }

        window.location.href = $currentURL + $chosenfilters;
      }
    }
  }]);

  return Filter;
}(_events.EventEmitter);

exports["default"] = Filter;

},{"events":1}],5:[function(require,module,exports){
"use strict";

require("./main/customers-library-scripts");

var _layoutHelpers = _interopRequireDefault(require("./layout-helpers"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

$(
/*#__PURE__*/
_asyncToGenerator(
/*#__PURE__*/
regeneratorRuntime.mark(function _callee() {
  var isUrl, setDownloadButtonUrl, quoteStyles;
  return regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          /**
           * The resource URL [optional]
           */
          isUrl = $('#is_url').val();
          /**
           * Changes the href of the downlod button based on the selected lang START
           * */

          setDownloadButtonUrl = function setDownloadButtonUrl() {
            if (isUrl == 'false' || typeof isUrl === 'undefined') {
              $('.download-btn').attr('href', $('.lang-select').val());
            } else {
              $('.download-btn').attr('href', isUrl);
            }

            $('.lang-select').on('change', function () {
              var selectedLang = $('.lang-select option:selected').val();
              $('.download-btn').attr('href', selectedLang);
            });
          };

          quoteStyles = function quoteStyles() {
            var quoteCounter = 1;
            $('.quote-div.case-study-row').each(function (_, e) {
              var sameClass = $(e).attr('row-number');
              var greyBoxBottom = $('.grey-box').offset().top + $('.grey-box').height();

              if ($(window).width() >= 1420) {
                var sameHeight = $('h2[row-number="' + sameClass + '"]').offset().top;

                if (quoteCounter == 1) {
                  if (greyBoxBottom >= sameHeight) {
                    $(e).offset({
                      top: sameHeight
                    }).css('position', 'initial');
                  } else {
                    $(e).offset({
                      top: sameHeight + 86
                    }).css('position', 'inherit');
                  }

                  quoteCounter++;
                } else {
                  $(e).offset({
                    top: sameHeight + 51
                  }).css('position', 'inherit');
                }
              } else {
                var under1420 = $('h2[row-number="' + sameClass + '"]').next();
                var sameHeightUnder1420 = under1420.height() / 2 + under1420.offset().top - $(e).height() / 2;
                $(e).offset({
                  top: sameHeightUnder1420
                }).css('position', 'inherit');
              }
            });
          };

          setDownloadButtonUrl();
          quoteStyles();
          (0, _layoutHelpers["default"])();

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));

},{"./layout-helpers":6,"./main/customers-library-scripts":7}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _responsiveHelper = _interopRequireDefault(require("./util/responsive-helper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _default() {
  function makeOffset() {
    var allFilters = document.querySelectorAll('.filter-btns');
    var layoutActiveClass = 'offset-right';

    var setLayout = function setLayout(selector, arr, method) {
      if (checkClasses(selector)) {
        method();
      } else {
        setBlockLayout(arr, selector);
      }
    }; // to check if there are classes which are added when filter is activated


    var checkClasses = function checkClasses(selector) {
      var blocks = _toConsumableArray(document.querySelectorAll(selector));

      var result = false;

      if (blocks.some(hasClassVisible) || blocks.some(hasClassHidden)) {
        return result = true;
      } else {
        return result = false;
      }

      function hasClassVisible(element) {
        return (' ' + element.className + ' ').indexOf('order-1') > -1;
      }

      function hasClassHidden(element) {
        return (' ' + element.className + ' ').indexOf('order-2') > -1;
      }

      return result;
    };

    var setBlockLayout = function setBlockLayout() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var selector = arguments.length > 1 ? arguments[1] : undefined;
      var blocks = document.querySelectorAll(selector ? selector : '.outer-card.order-1');
      var greyBlocks = document.querySelectorAll('.outer-card.grey-box');

      var visibleGreyBlocks = _toConsumableArray(greyBlocks).filter(function (el) {
        return el.style.display !== 'none';
      });

      var targets = _toConsumableArray(blocks).concat(visibleGreyBlocks);

      targets.forEach(function (el, i) {
        arr.indexOf(i + 1) > -1 ? el.classList.add(layoutActiveClass) : el.classList.remove(layoutActiveClass);
      });
      return blocks.length;
    };

    var clearBLockLayoutHeleper = function clearBLockLayoutHeleper() {
      var blocks = document.querySelectorAll('.outer-card');

      _toConsumableArray(blocks).forEach(function (el, i) {
        el.classList.remove(layoutActiveClass);
      });
    };

    var mobileFn = function mobileFn(e) {
      clearBLockLayoutHeleper();
      var chosenElemes = setBlockLayout([1]); // if (!chosenElemes) {
      //   setBlockLayout([1], '.outer-card.order-2');
      // }
    };

    var tabletFn = function tabletFn(e) {
      clearBLockLayoutHeleper();
      var chosenElemes = setBlockLayout([2]); // if (!chosenElemes) {
      //   setBlockLayout([2], '.outer-card.order-2');
      // }
      // if (chosenElemes === 1) {
      //   setBlockLayout([1], '.outer-card.order-2');
      // }
    };

    var desktoptFn = function desktoptFn(e) {
      clearBLockLayoutHeleper();
      var chosenElemes = setBlockLayout([2, 4]); // if (!chosenElemes) {
      //   setBlockLayout([2, 4], '.outer-card.order-2');
      // }
      // if (chosenElemes === 1) {
      //   setBlockLayout([1, 3], '.outer-card.order-2');
      // }
      // if (chosenElemes === 2) {
      //   setBlockLayout([2], '.outer-card.order-2');
      // }
      // if (chosenElemes === 3) {
      //   setBlockLayout([1], '.outer-card.order-2');
      // }
    };

    _responsiveHelper["default"].addRange({
      '768..1023': {
        on: function on() {
          setLayout('.outer-card', [1], mobileFn);

          _toConsumableArray(allFilters).forEach(function (el) {
            el.addEventListener('click', mobileFn);
          });
        },
        off: function off() {
          _toConsumableArray(allFilters).forEach(function (el) {
            el.removeEventListener('click', mobileFn);
          });

          clearBLockLayoutHeleper();
        }
      },
      '1024..1199': {
        on: function on() {
          setLayout('.outer-card', [2], tabletFn);

          _toConsumableArray(allFilters).forEach(function (el) {
            el.addEventListener('click', tabletFn);
          });
        },
        off: function off() {
          _toConsumableArray(allFilters).forEach(function (el) {
            el.removeEventListener('click', tabletFn);
          });

          clearBLockLayoutHeleper();
        }
      },
      '1200..': {
        on: function on() {
          setLayout('.outer-card', [2, 4], desktoptFn);

          _toConsumableArray(allFilters).forEach(function (el) {
            el.addEventListener('click', desktoptFn);
          });
        },
        off: function off() {
          _toConsumableArray(allFilters).forEach(function (el) {
            el.removeEventListener('click', desktoptFn);
          });

          clearBLockLayoutHeleper();
        }
      }
    });
  }

  function dropDownHelper() {
    var filter = document.querySelectorAll('.dropdown-menu .filter-btns');
    var activeClass = 'chosen';

    _toConsumableArray(filter).forEach(function (el) {
      el.addEventListener('click', function () {
        _toConsumableArray(filter).forEach(function (innerEl) {
          if (el != innerEl) {
            innerEl.classList.remove(activeClass);
          }
        });
      });
    });
  }

  makeOffset();
  dropDownHelper();
}

},{"./util/responsive-helper":9}],7:[function(require,module,exports){
"use strict";

var _dashboard = _interopRequireDefault(require("../components/dashboard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

$(function () {
  var dash = new _dashboard["default"]();
  if (window.hideYTActivated) return;
  var onYouTubeIframeAPIReadyCallbacks = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    var _loop = function _loop() {
      var playerWrap = _step.value;
      var playerFrame = playerWrap.querySelector('iframe');
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      var onPlayerStateChange = function onPlayerStateChange(event) {
        if (event.data == YT.PlayerState.ENDED) {
          playerWrap.classList.add('ended');
        } else if (event.data == YT.PlayerState.PAUSED) {
          playerWrap.classList.add('paused');
        } else if (event.data == YT.PlayerState.PLAYING) {
          playerWrap.classList.remove('ended');
          playerWrap.classList.remove('paused');
        }
      };

      var player = void 0;
      onYouTubeIframeAPIReadyCallbacks.push(function () {
        player = new YT.Player(playerFrame, {
          events: {
            onStateChange: onPlayerStateChange
          }
        });
      });
      playerWrap.addEventListener('click', function () {
        var playerState = player.getPlayerState();

        if (playerState == YT.PlayerState.ENDED) {
          player.seekTo(0);
        } else if (playerState == YT.PlayerState.PAUSED) {
          player.playVideo();
        }
      });
    };

    for (var _iterator = document.querySelectorAll('.hytPlayerWrap')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      _loop();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  window.onYouTubeIframeAPIReady = function () {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = onYouTubeIframeAPIReadyCallbacks[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var callback = _step2.value;
        callback();
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
          _iterator2["return"]();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  };

  window.hideYTActivated = true;
  $('#tesmonial-video').each(function () {
    var $video = $(this).find('iframe');
    var videoSrc = $video.attr('vidurl');
    $video.attr('src', videoSrc + '?rel=0&enablejsapi=1');
  });
  $('.iframe-div').on('click', function (e) {
    var iframeDiv = $(e.target);

    if (iframeDiv.hasClass('paused')) {
      iframeDiv.removeClass('paused');
    } else {
      // pause the video
      $('#tesmonial-video iframe')[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
  });
  $('#tesmonial-video').on('hidden.bs.modal', function () {
    // on closing the modal
    console.log('modal closed'); // stop the video

    $('#tesmonial-video iframe')[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
  });
});

},{"../components/dashboard":3}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var lib = {
  addEventListenerMultiple: function addEventListenerMultiple(element, events, handler) {
    events.split(' ').forEach(function (event) {
      return element.addEventListener(event, handler);
    });
  },
  removeEventListenerMultiple: function removeEventListenerMultiple(element, events, handler) {
    events.split(' ').forEach(function (event) {
      return element.removeEventListener(event, handler);
    });
  }
};
var _default = lib;
exports["default"] = _default;

},{}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lib = _interopRequireDefault(require("./lib.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ResponsiveHelper = function () {
  var handlers = [];
  var prevWinWidth;
  var nativeMatchMedia = false; // detect match media support

  if (window.matchMedia) {
    if (window.Window && window.matchMedia === Window.prototype.matchMedia) {
      nativeMatchMedia = true;
    } else if (window.matchMedia.toString().indexOf('native') > -1) {
      nativeMatchMedia = true;
    }
  } // prepare resize handler


  function resizeHandler() {
    var winWidth = window.innerWidth;

    if (winWidth !== prevWinWidth) {
      prevWinWidth = winWidth; // loop through range groups

      handlers.forEach(function (rangeObject) {
        // disable current active area if needed
        Object.keys(rangeObject.data).map(function (key) {
          var item = rangeObject.data[key];

          if (item.currentActive && !matchRange(item.range[0], item.range[1])) {
            item.currentActive = false;

            if (typeof item.disableCallback === 'function') {
              item.disableCallback();
            }
          }
        }); // enable areas that match current width

        Object.keys(rangeObject.data).map(function (key) {
          var item = rangeObject.data[key];

          if (!item.currentActive && matchRange(item.range[0], item.range[1])) {
            // make callback
            item.currentActive = true;

            if (typeof item.enableCallback === 'function') {
              item.enableCallback();
            }
          }
        });
      });
    }
  }

  _lib["default"].addEventListenerMultiple(window, 'load resize orientationchange', resizeHandler); // test range


  function matchRange(r1, r2) {
    var mediaQueryString = '';

    if (r1 > 0) {
      mediaQueryString += '(min-width: ' + r1 + 'px)';
    }

    if (r2 < Infinity) {
      mediaQueryString += (mediaQueryString ? ' and ' : '') + '(max-width: ' + r2 + 'px)';
    }

    return matchQuery(mediaQueryString, r1, r2);
  } // media query function


  function matchQuery(query, r1, r2) {
    if (window.matchMedia && nativeMatchMedia) {
      return matchMedia(query).matches;
    } else if (window.styleMedia) {
      return styleMedia.matchMedium(query);
    } else if (window.media) {
      return media.matchMedium(query);
    } else {
      return prevWinWidth >= r1 && prevWinWidth <= r2;
    }
  } // range parser


  function parseRange(rangeStr) {
    var rangeData = rangeStr.split('..');
    var x1 = parseInt(rangeData[0], 10) || -Infinity;
    var x2 = parseInt(rangeData[1], 10) || Infinity;
    return [x1, x2].sort(function (a, b) {
      return a - b;
    });
  } // export public functions


  return {
    addRange: function addRange(ranges) {
      // parse data and add items to collection
      var result = {
        data: {}
      };
      Object.keys(ranges).map(function (key) {
        result.data[key] = {
          range: parseRange(key),
          enableCallback: ranges[key].on,
          disableCallback: ranges[key].off
        };
      });
      handlers.push(result); // call resizeHandler to recalculate all events

      prevWinWidth = null;
      resizeHandler();
    }
  };
}();

var _default = ResponsiveHelper;
exports["default"] = _default;

},{"./lib.js":8}]},{},[2]);
